import Vue from 'vue';
import supplementalLinks from './supplemental-links.vue';


document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelectorAll('supplemental-links');

  el.forEach((element) => {
    const exhibitionId = Number.parseInt(element.getAttribute("exhibitionid")) || -1;
    const pdfs = JSON.parse(element.getAttribute("pdfs"));
    const sku = element.getAttribute("skuInfo");
    const index = element.getAttribute("index");
    new Vue({
      el: element,
      components: { supplementalLinks },
      data: { exhibitionId: exhibitionId, pdfs: pdfs, sku: sku },
      methods: {
        renderImageUrl: function (url) {
          let link = document.querySelector(`a[data-image-link="${index}"]`);
          if (url != "" && link != null) {
            link.removeAttribute('aria-disabled', true);
            link.classList.remove("link/disable");
            link.href = url;
          } else {
            if (link != undefined) {
              link.setAttribute('aria-disabled', true);
              link.classList.add("link/disable");
            }
          }
        }
      },
      template: `<supplementalLinks
        :exhibition-id="exhibitionId"
        :pdfs="pdfs"
        :sku="sku"
        v-on:imageUrl="renderImageUrl"
      />`
    });
  });
});
